import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LatteSpinner } from '../../components/common';
import { createConsultingSession } from '../../utils/sessionService';
import { useToast } from '../../context/ToastContext';

const ResumeNewPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user } = useAuth();
  const { showError } = useToast();
  const [isCreating, setIsCreating] = useState(false);
  const isCreatingRef = React.useRef(false); // useRef로 중복 방지
  
  // URL 파라미터에서 템플릿 정보 가져오기
  const templateId = searchParams.get('template');
  const shouldEdit = searchParams.get('edit') === 'true';
  
  useEffect(() => {
    // user가 없으면 세션 생성하지 않음
    if (!user) return;
    
    // 세션 생성
    const createNewResumeSession = async () => {
      // useRef를 사용한 중복 생성 방지
      if (isCreatingRef.current) return;
      isCreatingRef.current = true;
      
      setIsCreating(true);
      
      try {
        // 새 세션 생성 (사용자 이름 또는 기본값 사용)
        const sessionName = user.user_metadata?.full_name || user.user_metadata?.name || user.email || '새 이력서';
        const result = await createConsultingSession(user.id, sessionName);
        
        if (result && result.id) {
          // 템플릿과 편집 모드 정보를 포함하여 이력서 페이지로 리다이렉트
          const resumeUrl = `/resume/${result.id}?${templateId ? `template=${templateId}&` : ''}${shouldEdit ? 'edit=true' : ''}`;
          navigate(resumeUrl, { replace: true });
        } else {
          showError('세션 생성에 실패했습니다.');
          navigate('/');
        }
      } catch (error) {
        console.error('세션 생성 중 오류:', error);
        showError('세션 생성 중 오류가 발생했습니다.');
        navigate('/');
      }
    };
    
    createNewResumeSession();
  }, [user, navigate, templateId, shouldEdit, showError]); // searchParams 제거
  
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <LatteSpinner size="lg" className="mb-4" />
        <p className="text-gray-600">새로운 이력서를 준비하고 있습니다...</p>
      </div>
    </div>
  );
};

export default ResumeNewPage;